import * as yup from 'yup';
import {
  requiredMessage,
  name,
  email,
  taxId,
  numberValidation,
  street1,
  street2,
  city,
  state,
  zip,
  phone,
  genericStringValidation,
  duns,
} from '../../../../utils/validations';

const creditApplicationValiationSchema = yup.object().shape({
  requestedCreditLimit: numberValidation.required(requiredMessage),
  purchaseOrderAmount: numberValidation,
  requestedTermLimit: genericStringValidation.required(requiredMessage),
  otherRequestedTermLimit: genericStringValidation.when('requestedTermLimit', {
    is: 'Other',
    then: genericStringValidation
      .matches(/^[0-9]+$/, 'Net terms must be a number.')
      .required(requiredMessage),
  }),
  applicantName: name.required(requiredMessage),
  applicantTitle: genericStringValidation.required(requiredMessage),
  date: yup.date().required(requiredMessage),
  authorizedEmails: yup.array().of(
    yup.string().matches(/(.+)@(.+){2,}\.(.+){2,}/, {
      message: 'Remove or correct any invalid email addresses to continue.',
      excludeEmptyString: true,
    })
  ),
  invoiceEmail: email.required(requiredMessage),
  taxId: taxId.required(requiredMessage),
  duns: duns,
  financialDocs: yup.boolean().oneOf([true], requiredMessage),
  multiplePurchaseOrders: genericStringValidation.required(requiredMessage),
  entityName: name.required(requiredMessage),
  acctsPayablePhone: phone.required(requiredMessage),
  acctsPayableEmail: email.required(requiredMessage),
  street1: street1.required(requiredMessage),
  street2: street2.nullable(),
  city: city.required(requiredMessage),
  state: state.required(requiredMessage),
  zipcode: zip.required(requiredMessage),
});

const creditApplicationInitialValues = {
  entityName: '',
  acctsPayablePhone: '',
  acctsPayableEmail: '',
  street1: '',
  street2: '',
  city: '',
  state: '',
  zipcode: '',
  requestedCreditLimit: '',
  purchaseOrderAmount: '',
  requestedTermLimit: 'Net 30',
  otherRequestedTermLimit: '',
  applicantName: '',
  applicantTitle: '',
  date: new Date(),
  authorizedEmails: [],
  invoiceEmail: '',
  taxId: '',
  duns: '',
  financialDocs: false,
  multiplePurchaseOrders: 'false', // backend expects a boolean but Formik doesn't play nice with bolean Radio buttons.
  billingAccountId: '',
};

export { creditApplicationInitialValues, creditApplicationValiationSchema };
